module.exports = __webpack_public_path__ + "img/face-with-thermometer.05483588.png";